import { render, staticRenderFns } from "./PersonalDocumentsCreateForm.vue?vue&type=template&id=8caf796a&scoped=true"
import script from "./PersonalDocumentsCreateForm.vue?vue&type=script&lang=js"
export * from "./PersonalDocumentsCreateForm.vue?vue&type=script&lang=js"
import style0 from "./PersonalDocumentsCreateForm.vue?vue&type=style&index=0&id=8caf796a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8caf796a",
  null
  
)

export default component.exports